import React from 'react';
import PropTypes from 'prop-types';

import { HistoryEventType } from '../../../../../Model/CoachHistory';
import CoachNote from '../CoachNote';
import { getCoachHistoryInfo } from './util';
import FeesInfoTooltip from './FeesInfoTooltip';

import {
  StyledLoadingPage,
  ContentText,
  ActivityContainer,
} from './styles';
import texts from './texts';

const ActivityList = ({
  history,
  isReady,
}) => {
  if (!isReady) {
    return <StyledLoadingPage />;
  }

  if (!history.length) {
    return <ContentText>{texts.emptyText}</ContentText>;
  }

  return (
    <ActivityContainer>
      {history.map((doc) => {
        const { value, actionInfo } = getCoachHistoryInfo(doc);
        const meta = doc.metadata;

        return (
          <CoachNote
            key={doc.id}
            date={doc.createdAt}
            value={value}
            actionInfo={actionInfo}
            infoTooltip={doc.type === HistoryEventType.FEES_CONFIG_UPDATED ? <FeesInfoTooltip meta={meta} /> : null}
            note={meta?.note || ''}
            name={doc.actionedByUserName || ''}
          />
        );
      })}
    </ActivityContainer>
  );
};

ActivityList.propTypes = {
  history: PropTypes.array.isRequired,
  isReady: PropTypes.bool.isRequired,
};

export default ActivityList;
